export interface SessionState {
  isSidebarCollapsed: boolean;
  sessionUrl?: string;
}

/**
 * Create a state object for the session module.
 * @returns A state object initialized for the use in the session module.
 */
export function makeState(): SessionState {
  const sessionKey = localStorage.getItem("session");
  const sessionObject = sessionKey
    ? JSON.parse(window.atob(sessionKey))
    : undefined;
  return {
    isSidebarCollapsed: sessionObject?.isSidebarCollapsed || false,
    sessionUrl: sessionObject?.sessionUrl,
  };
}
